import {ENDPOINTS} from '@/config/constants'
import api, {HTTPMethod} from '@/helpers/api'
import {
  GetStepTypesRequest,
  GetStepTypesRequestSchema,
  GetStepTypesResponse,
  GetStepTypesResponseSchema,
} from '@/types/StepTypes'

export const getStepTypesService = (params: GetStepTypesRequest, signal?: AbortSignal) => {
  return api<GetStepTypesRequest, GetStepTypesResponse>({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_STEP_TYPES,
    requestSchema: GetStepTypesRequestSchema,
    responseSchema: GetStepTypesResponseSchema,
    signal,
  })(params)
}
